import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import * as Compontents from '@/components'

Vue.use(Router)

const routes = [{
  path: '/',
  redirect: '/cockpit'
},
{
  path: '/login',
  name: 'Login',
  component: Compontents.Login,
  meta: { requiresAuth: false }
},
{
  path: '/terms',
  name: 'Terms',
  component: Compontents.Terms,
  meta: { requiresAuth: false }
},
{
  path: '/register',
  name: 'Register',
  component: Compontents.Register,
  meta: { requiresAuth: false }
},
{
  path: '/password/reset',
  name: 'PassReset',
  component: Compontents.PassReset,
  meta: { requiresAuth: false }
},
{
  path: '/password/reset/:token/:email',
  name: 'PasswordChange',
  component: Compontents.PasswordChange,
  meta: { requiresAuth: false }
},
{
  path: '/password/sent',
  name: 'PassResetSent',
  component: Compontents.PassResetSent,
  meta: { requiresAuth: false }
},
{
  path: '/cockpit',
  name: 'Cockpit',
  component: Compontents.Cockpit,
  meta: { requiresAuth: true }
},
{
  path: '/campaigns',
  name: 'Campaigns',
  component: Compontents.Campaigns,
  meta: { requiresAuth: true }
},
{
  path: '/campaigns/:campaignID',
  name: 'Campaign',
  component: Compontents.Campaign,
  meta: { requiresAuth: true }
},
{
  path: '/user',
  name: 'User',
  component: Compontents.User,
  meta: { requiresAuth: true }
},
{
  path: '/user/delete',
  name: 'UserDelete',
  component: Compontents.UserDelete,
  meta: { requiresAuth: true }
}]

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js